import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';
import { apiAction as get } from './configurations/get';

export const apiActions = {
  cpdCategorys: {
    get
  }
}

const actions = mapActionsFromConfigurations('cpdCategorys')(configurations);

export { API_ENDPOINT } from './configurations/endpoints';

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/areas-of-advice/actions.js